import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f786f950"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "plan-cards-wrapper w-100" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Retiree Profile"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-control plus" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "plus iatse-icon-plus" }),
    /*#__PURE__*/_createElementVNode("span", { class: "line" })
  ])
], -1))
const _hoisted_4 = { class: "data-section w-100" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-between w-100"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Demographics", -1))
const _hoisted_7 = {
  key: 0,
  class: "fund-details"
}
const _hoisted_8 = { class: "fund-detail" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Name", -1))
const _hoisted_10 = { class: "fund-detail" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Participant ID", -1))
const _hoisted_12 = { class: "fund-detail" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "SSN", -1))
const _hoisted_14 = { class: "fund-detail" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Gender", -1))
const _hoisted_16 = { class: "fund-detail" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Marital Status", -1))
const _hoisted_18 = { class: "fund-detail" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Date of Marriage", -1))
const _hoisted_20 = { class: "fund-detail" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Date of Birth", -1))
const _hoisted_22 = { class: "fund-detail" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Street", -1))
const _hoisted_24 = { class: "fund-detail" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "City", -1))
const _hoisted_26 = { class: "fund-detail" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "State", -1))
const _hoisted_28 = { class: "fund-detail" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Country", -1))
const _hoisted_30 = { class: "fund-detail" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "ZIP", -1))
const _hoisted_32 = {
  key: 1,
  class: "fund-details"
}
const _hoisted_33 = { class: "fund-detail" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Name", -1))
const _hoisted_35 = { class: "fund-detail" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Participant ID", -1))
const _hoisted_37 = { class: "fund-detail" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "SSN", -1))
const _hoisted_39 = { class: "fund-detail" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Gender", -1))
const _hoisted_41 = { class: "fund-detail" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Marital Status", -1))
const _hoisted_43 = { class: "fund-detail" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Date of Marriage", -1))
const _hoisted_45 = { class: "fund-detail" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Date of Birth", -1))
const _hoisted_47 = { class: "fund-detail" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Street", -1))
const _hoisted_49 = { class: "fund-detail" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "City", -1))
const _hoisted_51 = { class: "fund-detail" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "State", -1))
const _hoisted_53 = { class: "fund-detail" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Country", -1))
const _hoisted_55 = { class: "fund-detail" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "ZIP", -1))
const _hoisted_57 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_58 = { class: "person-toggler" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "plan-summary__footer row w-100" }
const _hoisted_61 = { class: "col-12 col-md-4" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Other Coverages", -1))
const _hoisted_63 = { class: "account-actions" }
const _hoisted_64 = { class: "col-12 col-md-8" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Account Actions", -1))
const _hoisted_66 = { class: "action-buttons mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OtherCoverages = _resolveComponent("OtherCoverages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        ($setup.dataLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              ($setup.planSummary.SpouseDetails !== null)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "",
                    class: "links",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.toggleDetails && $setup.toggleDetails(...args)), ["prevent"]))
                  }, _toDisplayString($setup.showSpouseDetails ? 'View Participant Details' : 'View Spouse Details'), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            ($setup.dataLoaded)
              ? (_openBlock(), _createElementBlock("div", {
                  key: $setup.showSpouseDetails ? 'spouse' : 'participant'
                }, [
                  (!$setup.showSpouseDetails)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.Name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.PersonID), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.SSN), 1),
                          _createElementVNode("p", {
                            class: "plan-modal text-underline text-primary",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.openModal('recaptcha', 'Show SSN', 'modal-success')), ["prevent"]))
                          }, "Show SSN")
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.Gender), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.MaritalStatus), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.MarriageDate ?? 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.DateOfBirth), 1)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.Street), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.City), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.State ?? 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.Country?.value ?? 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonDetails.Zip ?? 'N/A'), 1)
                        ])
                      ]))
                    : ($setup.planSummary.SpouseDetails !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.Name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.PersonID), 1)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.SSN), 1),
                            _createElementVNode("p", {
                              class: "plan-modal text-underline text-primary",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.openModal('recaptcha', 'Show SSN', 'modal-success', null, {entity: $setup.planSummary.SpouseDetails.PersonID, Type: 'Spouse' })), ["prevent"]))
                            }, "Show SSN")
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.Gender), 1)
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.MaritalStatus), 1)
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _hoisted_44,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.MarriageDate ?? 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.DateOfBirth), 1)
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.Street), 1)
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.City), 1)
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.State ?? 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.Country?.value ?? 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _hoisted_56,
                            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.SpouseDetails.Zip), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.retireeTotals, (retireeData, personId) => {
            return (_openBlock(), _createElementBlock("button", {
              key: personId,
              class: _normalizeClass(["toggle-button", { active: $setup.selectedPersonId === personId }]),
              onClick: ($event: any) => ($setup.selectedPersonId = personId)
            }, _toDisplayString(retireeData.FullName), 11, _hoisted_59))
          }), 128))
        ]),
        _createElementVNode("a", {
          class: "btn btn-primary",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.openModal('hw-retiree-payments-history', 'Payments History', 'plan-retiree')), ["prevent"]))
        }, " Payments History ")
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_OtherCoverages, {
              otherCoverages: $setup.planSummary.OtherCoverages
            }, null, 8, ["otherCoverages"])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _hoisted_65,
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("a", {
              href: "",
              class: "btn btn-secondary plan-modal",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.openModal('add-beneficiary', 'My Beneficiary(ies)', 'plan-tables-striped beneficiary', null, null, null)), ["prevent"]))
            }, " Beneficiary(ies) "),
            _createElementVNode("a", {
              href: "#",
              class: "btn btn-secondary btn-large plan-modal",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.openModal('claims', 'Claims', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
            }, " Claims "),
            _createElementVNode("a", {
              href: "",
              class: "btn btn-secondary btn-large plan-modal",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => ($setup.openModal('dependents', 'My Dependents', null)), ["prevent"]))
            }, " My Dependents ")
          ])
        ])
      ])
    ])
  ]))
}